<template>
  <section 
    class="main-content-dialog" 
    role="dialog" 
    aria-labelledby="dialog-title"
  >
    <div class="wrap-dialog">
      <header class="flex justify-between items-center mb-4">
        <h1 id="dialog-title" class="text-[var(--amarelo)] m-0">{{ propsData.title }}</h1>
        <AppButton
          v-bind:visibility="true"
          left_icon="fa-regular fa-circle-xmark fa-xl"
          emitType="close"
          @close="close"
          :width="20"
          :height="20"
        />
      </header>
      
      <div class="dialog-message mb-4">
        {{ propsData.message }}
      </div>

      <div v-if="!propsData.confirm" class="textarea-container mb-4">
        <textarea
          :disabled="noButtons"
          class="text-area-1"
          name="observacao"
          id="observacao"
          placeholder="deixe uma observação..."
          v-model="observacao"
          rows="3"
        ></textarea>
      </div>

      <div class="flex justify-end gap-2 sm:gap-3 action-buttons">
        <button
          v-for="(button, index) in propsData.buttons"
          :key="index"
          class="action-button rounded-md"
          :style="{ backgroundColor: button.color }"
          @click="submitData(button.action)"
        >
          {{ button.text }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import { toast } from "vue3-toastify";
import AppButton from "@/components/button.vue";
export default {
  components: {
    AppButton,
  },
  props: {
    propsData: {
      type: Object,
      required: true,
      default: () => {
        return {
          title: "Tens certeza?",
          message: "Tens a certeza que queres apagar este registo?",
          buttons: [
            {
              text: "Sim",
              color: "#1f6a1fc1",
              action: "delete",
              entity: null,
            },
            {
              text: "Não",
              color: "#a83838",
              action: "cancel",
              entity: null,
            },
          ],
          confirm: false,
        };
      },
    },
  },

  data() {
    return {
      baseUrl: process.env.VUE_APP_URL_BASE,
      observacao: "",
    };
  },
  computed: {
    noButtons() {
      return this.propsData.buttons.length == 0;
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },

    async customMutation(entity = null, mutation = null) {
      if (entity == null || mutation == null) {
        console.log("Entity or mutation is null");
        return null;
      }

      let dataToChange = {
        status: mutation,
      };

      if (this.observacao) {
        dataToChange.descricao = this.observacao;
      }

      try {
        const res = axios.put(
          `${this.baseUrl}/api/v1/${entity}/editar/${
            this.propsData?.data?.id || 0
          }/`,
          dataToChange
        );

        if (entity == "planeamento") {
          let o_s_mutation = null;

          switch (mutation) {
            case "confirmado":
              o_s_mutation = "confirmado";
              break;
            case "cancelado":
              o_s_mutation = "remarcar";
              break;
            default:
              o_s_mutation = "";
          }

          try {
            if (o_s_mutation) {
              const res = axios.put(
                `${this.baseUrl}/api/v1/ordemservico/editar/${this.propsData?.data?.ordemservico}/`,
                { status: o_s_mutation }
              );
            } else {
              console.log("Mutation not found");
            }
          } catch (err) {
            console.log(err);
          }
        }

        return true;
      } catch (err) {
        console.log(err);
        return false;
      }
    },

    async submitData(action = "cancel") {
      let res = null;

      if (this.propsData.confirm) {
        this.$emit("confirmReturn", action);
        return;
      }

      if (action == "delete" || action == "eliminar" || action == "apagar") {
        res = this.customMutation(this.propsData.entity, "desativado");
      } else if (action == "aprovar") {
        res = this.customMutation(this.propsData.entity, "confirmado");
      } else if (action == "rejeitar") {
        res = this.customMutation(this.propsData.entity, "cancelado");
      } else if (action == "cancel" || action == "cancelar") {
        res = this.customMutation(this.propsData.entity, "cancelado");
      }
      if (res) {
        toast.success(`${this.propsData.entity} ${action} com sucesso!`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        this.$emit("close");
      } else {
        toast.error(`Erro ao ${action} ${this.propsData.entity}!`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      }
    },
    
    handleKeyDown(e) {
      if (e.key === 'Escape') {
        this.close();
      }
    }
  },
  created() {
    this.observacao = this.propsData.data?.descricao || "";
  },
  mounted() {
    // Prevent body scroll when dialog is open
    document.body.style.overflow = 'hidden';
    
    // Add ESC key listener
    document.addEventListener('keydown', this.handleKeyDown);
    
    // Focus trap
    this.$nextTick(() => {
      const focusableElements = this.$el.querySelectorAll(
        'button, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (focusableElements.length) {
        focusableElements[0].focus();
      }
    });
  },
  beforeDestroy() {
    // Restore body scroll
    document.body.style.overflow = '';
    
    // Remove ESC key listener
    document.removeEventListener('keydown', this.handleKeyDown);
  }
};
</script>

<style scoped>
.main-content-dialog {
  padding: 1em;
  background-color: var(--bg-pop-up);
  width: 100vw;
  height: 100dvh;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  z-index: 100000000;
  animation: fadeIn 0.2s ease-out;
}

.wrap-dialog {
  position: relative;
  padding: 1.5em;
  background: rgba(16, 21, 38, 0.96);
  color: var(--text);
  border: 1px solid var(--glass-border);
  border-radius: var(--glass-radius);
  box-shadow: var(--glass-shadow);
  backdrop-filter: blur(16px);
  
  /* Responsive width */
  width: 90%;
  max-width: 500px;
  height: auto;
  
  /* Minimum dimensions */
  min-height: 10em;
  
  /* Layout */
  display: flex;
  flex-direction: column;
  animation: slideIn 0.3s ease-out;
}

h1 {
  font-size: clamp(1.2rem, 5vw, 1.5rem);
  margin-bottom: 0.5em;
}

.dialog-message {
  font-size: clamp(0.9rem, 4vw, 1rem);
}

.text-area-1 {
  width: 100%;
  min-height: 80px;
  padding: 0.75em;
  margin: 0.5em 0;
  border-radius: 0.3em;
  resize: vertical;
  font-size: clamp(0.85rem, 3vw, 0.95rem);
}

button.action-button {
  padding: 0.5em 1.2em !important;
  font-size: clamp(0.85rem, 3.5vw, 0.95rem) !important;
  min-width: 70px;
  font-weight: 500;
  transition: transform 0.15s ease-in-out, opacity 0.15s;
}

button.action-button:hover {
  transform: translateY(-2px);
  opacity: 0.9;
}

button.action-button:active {
  transform: translateY(0);
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideIn {
  from { 
    transform: translateY(20px);
    opacity: 0; 
  }
  to { 
    transform: translateY(0);
    opacity: 1; 
  }
}

/* Media queries for different screen sizes */
@media (max-width: 768px) {
  .wrap-dialog {
    width: 92%;
    padding: 1.2em;
    min-width: unset;
  }
  
  .main-content-dialog {
    padding: 0.75em;
  }
}

@media (max-width: 480px) {
  .wrap-dialog {
    width: 95%;
    padding: 1em;
  }
  
  /* Make buttons more touch-friendly on mobile */
  .action-buttons {
    margin-top: 0.5em;
  }
  
  button.action-button {
    padding: 0.6em 1em !important;
    min-height: 42px;
  }
  
  /* Smaller margins on mobile */
  .mb-4 {
    margin-bottom: 0.75em;
  }
}

@media (max-width: 360px) {
  /* For very small screens, stack buttons */
  .action-buttons {
    flex-direction: column;
    align-items: stretch;
    gap: 0.5em;
  }
  
  .text-area-1 {
    min-height: 60px;
  }
}

textarea:disabled {
  background-color: rgba(255, 255, 255, 0.06);
  color: var(--glass-muted);
}
</style>